
    import React from 'react'
    import Base from '@ucheba/ui/components/Icon'
    import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js"
    import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js"

    const symbol = new SpriteSymbol({
  "id": "icon__restart",
  "use": "icon__restart-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon__restart\"><defs><clipPath id=\"icon__restart_a\"><path d=\"M1280 0v5935H0V0h1280z\" /></clipPath><clipPath id=\"icon__restart_b\"><path d=\"M7.5 0v7.5L4.133 4.132A8.972 8.972 0 0 0 1.5 10.5c0 4.98 4.02 9 9 9s9-4.02 9-9-4.02-9-9-9V0C16.286 0 21 4.714 21 10.5S16.286 21 10.5 21 0 16.286 0 10.5c0-2.893 1.178-5.518 3.08-7.42L0 0h7.5z\" /></clipPath></defs><g clip-path=\"url(#icon__restart_a)\" transform=\"translate(-928 -260)\"><g clip-path=\"url(#icon__restart_b)\" transform=\"translate(929.5 261.5)\"><path fill=\"currentColor\" d=\"M0 0h21v21H0V0z\" /></g></g></symbol>"
})
    sprite.add(symbol)

    export default React.memo(function IconRestartIcon(props) {
      const { className, ...restProps } = props
      return <Base.Icon className={className} id="icon__restart" {...restProps} />
    })
  